module.exports = __webpack_public_path__ + "static/media/linkedin.34c3c12a.svg";